import axios from "axios";
import { FAVOURITE_LIST } from "./types";

const PROXY = process.env.REACT_APP_URL + "api/";

export const getfavriteList = () => async (dispatch) => {
  try {
    const res = await axios.get(`${PROXY}favourite`);
    dispatch({
      type: FAVOURITE_LIST,
      payload: res.data.result,
    });

    return res.data.result;
  } catch (err) {
    console.error(err);
  }
};
